// setInterval that pauses while the tab is hidden and fires once immediately when it becomes visible again.
export function visibleInterval(fn, ms) {
  let id = null;
  const start = () => { if (id == null) id = setInterval(fn, ms); };
  const stop = () => { if (id != null) { clearInterval(id); id = null; } };
  const onVis = () => {
    if (document.hidden) stop();
    else { fn(); start(); }
  };
  if (!document.hidden) start();
  document.addEventListener("visibilitychange", onVis);
  return () => { stop(); document.removeEventListener("visibilitychange", onVis); };
}
